
































import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import jsmd5 from 'js-md5'
import { setStore, removeStore, getStore, encrypt, decrypt } from '@/utils/utils'
import protocol from './protocol.vue'
import { ValidateField } from '@/components'
import md5 from 'md5'
const login = namespace('login')
const commonModules = namespace('commonModules')

@Component({
  components: {
    protocol,
    ValidateField,
  },
})
export default class Login extends Vue {
  @login.Action queryUuid
  @login.Action ensureProtocol
  @login.Action sendVerCode
  @login.Action checkVerCode
  @commonModules.Action checkOpenUser

  showProtocol = false
  userInfo: any = {}
  formParams = {
    certId: '',
    // passWord: '',
    verCode: '',
  }
  msgDisabled: Boolean = true // 验证码
  time: Number = 0
  counts: string = 's后重新发送'
  isSend: Boolean = false
  btnLoading: Boolean = false
  //   get isApp() {
  //     return getStore('setAppStatus')
  //   }
  //   校验身份证
  validateCertId(val) {
    let check =
      /^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|82|[7-9]1)[0-9]{4}(((19|20)[0-9]{2}(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((19|20)(0[48]|[2468][048]|[13579][26])0229)|(20000229))[0-9]{3}[0-9Xx]$/
    return check.test(val)
  }
  validate() {
    if (!this.formParams.certId) {
      this.$toast.fail('请输入证件号')
      return
    }
    if (
      !/^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|82|[7-9]1)[0-9]{4}(((19|20)[0-9]{2}(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-8]))))|((19|20)(0[48]|[2468][048]|[13579][26])0229)|(20000229))[0-9]{3}[0-9Xx]$/.test(
        this.formParams['certId']
      )
    ) {
      this.$toast.fail('请输入正确格式的证件号')
      return
    }
    // !this.isApp &&
    // if (!this.formParams.passWord) {
    //   this.$toast.fail('请输入登录密码')
    //   return
    // }
    if (!this.formParams.verCode) {
      this.$toast.fail('请输入验证码')
      return
    }
    return true
  }
  loginHome() {
    if (this.validate()) {
      //校验验证码
      this.checkVerCode({
        verCode: md5(this.formParams.verCode),
        certId: this.formParams.certId,
      }).then((res) => {
        if (res.code == 200) {
          removeStore('userInfo')
          removeStore('totalAmt')
          removeStore('pageType')
          removeStore('loanId')
          removeStore('reimbursementType')
          removeStore('userInfoAppliaction')
          removeStore('ticketId')
          removeStore('msgShow')
          removeStore('credAmt')
          removeStore('openLinesFlag')
          removeStore('billMonth')
          removeStore('protocolCheck')
          removeStore('proComCheck')
          removeStore('proCommonCount')
          removeStore('proBankRegistCount')
          //   removeStore('passWord')
          //   removeStore('setAppStatus')
          //   502--成功  200---未开通  501 --人工审批  503--拒绝
          let params: any = { certId: this.formParams.certId }
          //   if (!this.isApp) {
          //   params.passWord = jsmd5(this.formParams.passWord)
          params.verCode = this.formParams.verCode
          //   }
          this.queryUuid(params).then((res: any) => {
            if (res && res['code'] == 502) {
              // 存储用户信息
              let userInfo = {
                custId: res.data.custId, // 编号
                certId: res.data.certId, // 身份证号
                custName: res.data.custName, // 用户姓名
                accNo: res.data.accNo, // 银行卡号
                accMobile: res.data.accMobile, //预留手机号
                mobile: res.data.mobile, //手机号
                password: res.data.password, // 支付密码
                credId: res.data.credId, // 额度id
              }
              this.userInfo = userInfo
              setStore('token', res.data.token)
              if (res.data.picture) {
                setStore('userImg', res.data.picture) // 存储 用户图片
              } else {
                setStore('userImg', '1.png') // 默认第一张
              }
              setStore('userInfo', JSON.stringify(userInfo))
              //   setStore('passWord', encrypt(this.formParams.passWord))
              //   setStore('passWord', encrypt(res.data.passWord))
              if (res.data.prodChgFlag == '1') {
                // 需要重新签订协议
                this.showProtocol = true
              } else {
                // 无需重新签订
                this.$toast.success('登录成功')
                window.location.href = '/quotaManageIndex'
                // this.$router.push({
                //   path: '/quotaManageIndex',
                //   query: { flag: 'success' },
                // })
              }
            } else if (res && res['code'] == 200) {
              //   this.$toast.fail('请先开通东航分期付')
              let userInfo = {
                certId: this.formParams.certId,
              }
              setStore('userInfo', JSON.stringify(userInfo)) // 用于申请注册页面返显
              this.$router.replace('/home')
            } else if (res && res['code'] == 501) {
              //   人工审批中
              //   this.$router.push({
              //     path: '/resultShow',
              //     query: { type: res['code'], msg: res.msg || '人工审批中', flag: 'login' },
              //   })
              this.$router.replace('/home')
            } else if (res && res['code'] == 503) {
              // 申请失败
              this.$router.replace('/home')

              //   let userInfo = {
              //     certId: this.formParams.certId,
              //   }
              //   setStore('userInfo', JSON.stringify(userInfo)) // 用于申请注册页面返显
              //   this.$router.push({
              //     path: '/resultShow',
              //     query: { type: res['code'], msg: res.msg || '申请失败', flag: 'login' },
              //   })
            }
          })
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }

  notionClick() {
    this.$router.push('/home')
  }
  closeProtocol() {
    this.showProtocol = false
  }
  ensurePro() {
    this.ensureProtocol({
      certId: this.userInfo.certId, // 身份证号
      custName: this.userInfo.custName, // 用户姓名
    }).then((data) => {
      this.showProtocol = false
      this.$toast.success('签订成功')
      window.location.href = '/quotaManageIndex'
      //   this.$router.push({
      //     path: '/quotaManageIndex',
      //     query: { flag: 'success' },
      //   })
    })
  }

  //   发送验证码
  onSendMessage() {
    if (!this.formParams.certId) {
      this.$toast('请输入证件号')
      return
    }
    this.time = 60
    let param = {
      certId: this.formParams.certId,
    }
    this.btnLoading = true
    this.sendVerCode(param).then((res) => {
      if (res.code === 200) {
        this.btnLoading = false
        this.isSend = true
        this.$toast.success('发送成功')
        let timer
        timer = setInterval(() => {
          if (this.time == 0) {
            clearInterval(timer)
            this.msgDisabled = false
            this.isSend = false
            return
          }
          this.time = Number(this.time) - 1
        }, 1000)
      } else {
        this.$toast.fail(res.msg)
        this.btnLoading = false
      }
    })
  }

  blurCertId() {
    if (this.validateCertId(this.formParams.certId)) {
      this.msgDisabled = false
    } else {
      this.msgDisabled = true
    }
  }
}
